import { StylePortal } from '@components/ui';
import { StylePortalProps } from '@components/ui/types';
import { ActionList, ActionListProps, Button, Popover } from '@shopify/polaris';
import { FunctionComponent, useCallback, useState } from 'react';

const polarisPositionedOverlayCssClass = 'Polaris-PositionedOverlay';

export type NavBarItemProps = {
  text: string;
  items?: ActionListProps;
  onClick?: () => void;
} & Partial<StylePortalProps>;

const NavBarItem: FunctionComponent<NavBarItemProps> = ({
  items,
  onClick,
  parentCssClass = polarisPositionedOverlayCssClass,
  styled,
  text,
}) => {
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const activator = (
    <Button onClick={onClick ?? toggleActive} disclosure={Boolean(items)}>
      {text}
    </Button>
  );

  return (
    <>
      {items ? (
        <Popover active={active} activator={activator} onClose={toggleActive}>
          <StylePortal parentCssClass={parentCssClass} styled={styled}>
            {items && <ActionList {...items} />}
          </StylePortal>
        </Popover>
      ) : (
        activator
      )}
    </>
  );
};

export default NavBarItem;
